import CustomerDetailsContainer from './CustomerDetailsContainer';
export default CustomerDetailsContainer;
